import axiosClient from "../api/axiosClient";

// Public, CMS-managed website URLs. Legal links must be resolved from this
// endpoint rather than duplicated in the panel so website updates take effect
// everywhere without a frontend release.
export const getWebsiteLinks = () => axiosClient.get("/website-links");
